(function () {
    'use strict';

    angular.module('Directives').directive('bbaMap', bbaMap);
    bbaMap.$inject = [
        '$q',
        '$rootScope',
        'MapLegendsConst',
        '$timeout',
        'customPopup',
        '$interval',
        'TypeStatusConsts',
        'Units',
        'toastr',
        'GoogleMapService'
    ];

    function bbaMap(
        $q,
        $rootScope,
        MapLegendsConst,
        $timeout,
        customPopup,
        $interval,
        TypeStatusConsts,
        Units,
        toastr,
        GoogleMapService
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaMap.html',
            scope: {
                mapData: '=',
            },
            link: bbaMapDirectiveLink,
        };

        function bbaMapDirectiveLink(scope, element, attrs) {
            let googleMapInstance; // holds the google map instance 

            // variable forward declarations
            const imageBaseUrl = "/images/map_icons/";
            const infoWindowTmpls = {
                job: '/templates/pages/jobs/add-ons/jobInfoWindow.html',
                cluster: '/templates/pages/jobs/add-ons/clusterInfoWindow.html',
                driver: '/templates/pages/jobs/add-ons/driverInfoWindow.html',
                depot: '/templates/pages/jobs/add-ons/depotInfoWindow.html'
            };

            scope.viewJobDriver = viewJobDriver;
            scope.viewJobArea = viewJobArea;
            scope.viewJobRoute = viewJobRoute;

            scope.TypeStatusConsts = TypeStatusConsts;
            scope.legends = MapLegendsConst;
            scope.showMapLegend = false;
            scope.infowIndowTemplate = ""; // info window template that will be used 
            scope.infoWindowContent = null; // infow window data

            let driversRawData = [];
            let driverMarkers = [];
            let jobMarkers = [];
            let warehouseMarkers = [];
            let routeDrawn = null;
            let mapBounds = null;
            let infoWindow = null;
            let markerCluster = null;


            // method forward declarations
            scope.init = init;
            scope.toggleMapLegends = toggleMapLegends;
            scope.getPackagesFormatted = getPackagesFormatted;
            scope.getBatchViewFormat = getBatchViewFormat;

            function init() {
                initMap();
                panMapToMarkerPosition();
                panMapToOfficeLocation();

                scope.$watch('mapData', mapData => {
                    showDriverPositionOnMap(mapData.drivers);
                }, true);

                // close info window when there are new jobs loaed 
                scope.$watch('mapData.jobs', (jobs) => {
                    showJobsPositionOnMap(jobs)
                    infoWindow.close();
                }, true);

                scope.$watch('mapData.wayPoints', (wayPoints) => {
                    if (!angular.equals({}, wayPoints.points)) {
                        drawRouteWayPoints(googleMapInstance, wayPoints.points, wayPoints.office);
                    } else {
                        if (routeDrawn != null) {
                            routeDrawn.setMap(null);
                            routeDrawn = null;
                        }
                    }
                }, true);

                scope.$watch('mapData.focusDriver', focusDriver => {
                    if (!angular.equals({}, focusDriver)) {
                        driverMarkers.forEach(marker => {
                            if (marker.id != focusDriver.id) {
                                marker.setMap(null);
                            }
                        });
                    } else {
                        driverMarkers.forEach(marker => {
                            marker.setMap(googleMapInstance);
                        })
                    }
                }, true);
            }


            function toggleMapLegends(show) {
                scope.showMapLegend = !show;
            }

            function getPackagesFormatted(job) {
                return job.packages ? job.packages.map(pack => {
                    const mUnit = Units.getMeasureUnit(pack.measureUnit);
                    const wUnit = Units.getWeightUnit(pack.weightUnit);
                    return pack.name || (`${pack.length} ${mUnit} x ${pack.length} ${mUnit} x ${pack.height} ${mUnit} / ${pack.weight} ${wUnit} (${pack.quantity} packs)`)
                }) : []
            }

            function getBatchViewFormat(item) {
                if (!item.batch || item.batch.batchId === 0) {
                    return `N/A (AD HOC Job)`;
                }
                const batch = item.batch || {};
                const weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
                const totalPackagesCubicWeightFormatted = `(${batch.totalPackagesCubicWeight} ${weightUnit})`;
                return `${batch.batchId} (${batch.totalJobsNumber} Jobs) ${totalPackagesCubicWeightFormatted}`;
            }

            function initMap() {
                infoWindow = new customPopup('jobMapInfoWindow');
                googleMapInstance = new google.maps.Map(document.getElementById('map'), {
                    disableDefaultUI: true,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    }
                });
                googleMapInstance.addListener('click', () => {
                    infoWindow.close();
                });
            }

            function panMapToMarkerPosition() {
                scope.$watch('mapData.jobToFocus', jobToFocus => {
                    if (jobToFocus !== undefined) {
                        const markerToFocus = jobMarkers.find(marker => marker.job.id === jobToFocus.id);

                        if(markerToFocus !== undefined) {
                            markerToFocus.setInfoWindow();
                            infoWindow.open(googleMapInstance, markerToFocus);

                            // zoom to marker position
                            $timeout(() => {
                                googleMapInstance.setZoom(19);
                                googleMapInstance.panTo(markerToFocus.position);
                            });
                        } else {
                            toastr.warning('Job has no location');
                        }
                    }
                }, true);
            }

            function panMapToOfficeLocation() {
                scope.$watch('mapData.office', office => {
                    if (scope.mapData.office === null) { return; }

                    const payload = {
                        serviceName: 'admin AU', 
                        methodName: 'getLatLng',
                        address: scope.mapData.office.address
                    };
                    GoogleMapService.geocoder(success => {
                        googleMapInstance.panTo(success);
                        googleMapInstance.setZoom(14);
                        createOfficeWarehouseLocationMarker(scope.mapData.office, success);
                    }, error => {
                        toastr.error(error.message, 'Error');
                    }, payload);

                }, true);
            }

            function createOfficeWarehouseLocationMarker(officeData, position) {
                let image = MapLegendsConst.getIcons('locations').url;
                let officeLocationMarker = new google.maps.Marker({
                    position: position,
                    map: googleMapInstance,
                    icon: image,
                    setInfoWindow: () => setWarehouseInfoWindowContent(officeData)
                });
                officeLocationMarker.addListener('click', () => {
                    officeLocationMarker.setInfoWindow();
                    infoWindow.close();
                    $timeout(() => infoWindow.open(googleMapInstance, officeLocationMarker));
                });
                warehouseMarkers.push(officeLocationMarker);
            }

            function setWarehouseInfoWindowContent(office) {
                scope.infoWindowContent = office.officeData;
                scope.infowIndowTemplate = infoWindowTmpls.depot;
            }

            function showDriverPositionOnMap(drivers) {
                driversRawData = drivers;
                drivers.forEach(driverData => {
                    updateCreateDriverMarker(driverData);
                });
            }

            function updateCreateDriverMarker(driverData) {
                let existingMarker = driverMarkers.filter(data => {
                    return data.id == driverData.id;
                });

                if (existingMarker.length == 0) {
                    let image = `${imageBaseUrl}${angular.getObjVal(driverData, 'currentVehicle.vehicleType.icon') ? angular.getObjVal(driverData, 'currentVehicle.vehicleType.icon').toUpperCase() : 'CAR'}.png`;
                    let driverMarker = new google.maps.Marker({
                        position: {
                            lat: parseFloat(driverData.latitude),
                            lng: parseFloat(driverData.longitude)
                        },
                        map: googleMapInstance,
                        icon: image,
                        setInfoWindow: () => setDriverInforWindowContent(driverData)
                    });
                    driverMarker.driver = true;
                    driverMarker.job = {};
                    driverMarker.addListener('click', () => {
                        driverMarker.setInfoWindow();
                        infoWindow.close();
                        $timeout(() => infoWindow.open(googleMapInstance, driverMarker));
                    });
                    driverMarker.id = driverData.id;
                    driverMarkers.push(driverMarker);
                } else {
                    if (driverData.active) {
                        existingMarker[0].setMap(googleMapInstance);
                        existingMarker[0].setPosition({
                            lat: parseFloat(driverData.latitude),
                            lng: parseFloat(driverData.longitude)
                        });
                    } else {
                        existingMarker[0].setMap(null);
                    }
                }
            }

            function setDriverInforWindowContent(driverData) {
                scope.angular = angular;
                scope.infoWindowContent = driverData;
                scope.infowIndowTemplate = infoWindowTmpls.driver;
            }

            function showJobsPositionOnMap(jobs) {
                mapBounds = new google.maps.LatLngBounds();
                if (markerCluster != null) { markerCluster.clearMarkers(); }
                removeJobIcons();
                jobMarkers = [];

                // create cluster for the jobs
                if (jobs.length !== 0) {
                    jobs.forEach(job => {
                        createJobMarkerOnMap(job);
                    });
                    createClusterIcon(jobMarkers);
                }

                // TODO CHECK THIS ONE I THINK THERE IS A BUG IN HERE..
                // add focus driver in map bounds
                if (!angular.equals({}, scope.mapData.focusDriver) && scope.mapData.focusDriver !== undefined) {
                    const driverToFocus = driverMarkers.find(marker => marker.id === scope.mapData.focusDriver.id);
                    if (driverToFocus !== undefined) {
                        if (jobs.length === 0) {
                            $timeout(() => {
                                googleMapInstance.setZoom(19);
                                googleMapInstance.panTo(driverToFocus.position);
                            });
                        } else {
                            const bounds = angular.extend(mapBounds, driverToFocus.position);
                            googleMapInstance.fitBounds(bounds);
                        }
                    }
                } else if (jobs.length !== 0) {
                    googleMapInstance.fitBounds(mapBounds);
                }
            }

            function createJobMarkerOnMap(jobData) {
                let isDelivery = isJobDelivery(jobData.jobStatus);
                const position = isDelivery ? jobData.destinationAddress : jobData.sourceAddress;

                if(position.latitude && position.longitude) {
                    let jobMarker = new google.maps.Marker({
                        position: {
                            lat: parseFloat(position.latitude),
                            lng: parseFloat(position.longitude)
                        },
                        map: googleMapInstance,
                        icon: jobData.icon,
                        job: jobData,
                        setInfoWindow: () => setJobInfoWindowContent(jobData)
                    });
                    jobMarker.addListener('click', () => {
                        jobMarker.setInfoWindow();
                        infoWindow.close();
                        $timeout(() => infoWindow.open(googleMapInstance, jobMarker));
                    });

                    jobMarkers.push(jobMarker);
                    mapBounds.extend(jobMarker.position);
                }
            }

            function isJobDelivery(jobStatus) {
                let isDelivery;
                switch (jobStatus) {
                    case 'notyetstarted':
                    case 'unassigned':
                    case 'pending':
                    case 'accepted':
                        isDelivery = false;
                        break;
                    case 'received':
                    case 'inprogress':
                    case 'delivered':
                    case 'failed':
                        isDelivery = true;
                        break;
                    default:
                        isDelivery = false;
                        break;
                }
                return isDelivery;
            }

            function setJobInfoWindowContent(jobData) {
                scope.infoWindowContent = jobData;
                scope.infowIndowTemplate = infoWindowTmpls.job;
            }

            function createClusterIcon(markers) {
                let styles = [
                    {
                        height: 55,
                        url: MapLegendsConst.getClusterIcon('accepted'),
                        width: 56,
                        textColor: "white"
                    }
                ];
                //TODO 
                //find a better way to implement this one
                //markers.push(...driverMarkers);
                markerCluster = new MarkerClusterer(googleMapInstance, markers, {
                    averageCenter: true,
                    imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                    styles
                });
                // leverage google map idle event to set a custom icon for the markers
                googleMapInstance.addListener('idle', () => {
                    setClusterIcon();
                });

                // set cluster click listener
                google.maps.event.addListener(markerCluster, 'clusterclick', function (cluster) {
                    $timeout(() => {
                        if (cluster.map_.zoom >= 20) {
                            if (cluster.markerClusterer_.clusters_.length != 0) {
                                infoWindow.close();
                                setClusterInfoWindow(cluster.markerClusterer_.clusters_[0].markers_.map(marker => marker.job));
                                infoWindow.setPosition(cluster.getCenter());
                                $timeout(() => infoWindow.open(googleMapInstance));
                            }
                        }
                    });
                });

            }

            function setClusterIcon() {
                const clusterInterval = $interval(() => {
                    if (markerCluster.clusters_) {
                        if (markerCluster.clusters_.find(cluster => !cluster.clusterIcon_.div_)) {
                            return false;
                        }
                        markerCluster.clusters_.map(cluster => {
                            if (cluster.markers_.find(marker => marker.job.jobStatus === 'failed')) {
                                setIcon(MapLegendsConst.getClusterIcon('failed'));
                            }
                            else if (cluster.markers_.find(marker => marker.job.jobStatus === 'unassigned')) {
                                setIcon(MapLegendsConst.getClusterIcon('unassigned'));
                            }
                            else if (cluster.markers_.find(marker => marker.job.jobStatus === 'accepted')) {
                                setIcon(MapLegendsConst.getClusterIcon('accepted'));
                            }
                            else if (cluster.markers_.find(marker => marker.job.jobStatus === 'pending')) {
                                setIcon(MapLegendsConst.getClusterIcon('pending'));
                            }
                            else if(cluster.markers_.find(marker => marker.job.jobStatus === 'rejected')) {
                                setIcon(MapLegendsConst.getClusterIcon('rejected'));
                            }
                            else if(cluster.markers_.find(marker => marker.job.jobStatus === 'delivered')) {
                                setIcon(MapLegendsConst.getClusterIcon('delivered'));
                            }
                            else if (cluster.markers_.find(marker => marker.driver === true)) {
                                // need to add marker for derivers
                                setIcon(MapLegendsConst.getClusterIcon('accepted'));
                            }
                            else {
                                setIcon(MapLegendsConst.getClusterIcon('accepted'));
                            }
                            function setIcon(path) {
                                if (angular.getObjVal(cluster, 'clusterIcon_')) {
                                    cluster.clusterIcon_.div_.style.backgroundImage = `url('${path}')`;
                                }
                            }
                        });
                        $interval.cancel(clusterInterval);
                    }
                });
            }

            function setClusterInfoWindow(clusterData) {
                scope.angular = angular;
                scope.infoWindowContent = clusterData;
                scope.infowIndowTemplate = infoWindowTmpls.cluster;
            }

            function removeJobIcons() {
                jobMarkers.forEach(marker => {
                    marker.setMap(null);
                });
            }

            function viewJobRoute(job) {
                $rootScope.$broadcast("viewJobRoute", job);
            }

            function drawRouteWayPoints(map, route, office) {
                if (angular.getObjVal(office, 'geoLocation.latitude') && angular.getObjVal(office, 'geoLocation.longitude')) {
                    createOfficeWarehouseLocationMarker(office, {
                        lat: parseFloat(office.geoLocation.latitude),
                        lng: parseFloat(office.geoLocation.longitude)
                    });
                }
                if (!route) {
                    return null;
                }

                const decoded = google.maps.geometry.encoding.decodePath(route.overviewPolyline.encodedPath);
                routeDrawn = new google.maps.Polyline({
                    path: decoded,
                    strokeColor: '#ef2139',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    zIndex: 3,
                    routeObj: office
                });
                routeDrawn.setMap(map);
                $timeout(() => {
                    googleMapInstance.setZoom(14);
                }, 100);
            }

            function viewJobArea(job) {
                $rootScope.$broadcast("viewJobArea", job.route.area);
            }
            function viewJobDriver(job) {
                $rootScope.$broadcast("viewJobDriver", job.driver);
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/bbaMap.js